import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { userAuthTokenLoginRequestAction } from '../../../../redux/actions/userAuthorization.actions';
import { purgeAndReconnectAction } from '../../../../redux/actions/shared.actions';
import ApiGameService from 'services/ApiService/ApiGameService/ApiGameService';
export default function ViewApiAuthentication() {
    var dispatch = useDispatch();
    var navigate = useNavigate();
    var _a = useParams(), token = _a.token, gameToken = _a.gameToken;
    var queryParams = new URLSearchParams(window.location.search);
    var redirect = queryParams.get('redirect') || '/games';
    useEffect(function () {
        dispatch(userAuthTokenLoginRequestAction(token)).then(function (loginResponse) {
            if (!gameToken) {
                navigate(redirect);
                return;
            }
            ApiGameService.requestGames(token).then(function (response) {
                var hasAccess = loginResponse.message.rank === 'ADMIN';
                for (var index in response.data) {
                    if (response.data[index].token === gameToken) {
                        hasAccess = true;
                        break;
                    }
                }
                if (hasAccess) {
                    dispatch(purgeAndReconnectAction(gameToken))
                        .then(function () { return navigate(redirect); })
                        .catch(function (error) {
                        console.error('Error connecting to websocket:', error);
                        navigate('/games');
                    });
                }
                else {
                    navigate('/games');
                }
            }).catch(function (error) {
                console.error('Error fetching games:', error);
                navigate('/games');
            });
        }).catch(function (error) {
            console.error('Error authenticating token login:', error);
            navigate('/login');
        });
    }, [token, gameToken, redirect]);
    return null;
}
